// import { IconPickerItem } from "react-fa-icon-picker";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { BLUE_ARROW_RIGHT, DOT } from "../../assets/image";
import { RootState } from "../../store/store";
import AvailableButton, { UnavailableButton } from "../buttons/availabeButton";


interface IVerificationLayoutApartmentCard {
    location: string,
    pricing: string,
    additionalFeatures?: IVerificationLayoutApartmentCardFeatures[],
    rooms?: string[],
    img: string,
    id: string,
    availableAt: string,
    slug: string,
    booking_status?: string
}
interface IVerificationLayoutApartmentCardFeatures {
    feature: string,
    icon: string
}
const VerificationLayoutApartmentCard = (props: IVerificationLayoutApartmentCard) => {
    const { isAvailableForBooking } = useSelector((state: RootState) => state.booking)
    const router = useNavigate();

    const formatBookingStatus = (status: string) => {
        if (!status) return '';
        return status
            .split('-')
            .map(word => word.charAt(0).toUpperCase() + word.slice(1))
            .join(' ');
    };

    const getStatusColor = (status:string) => {
        // Get the first part of the status (before the hyphen)
        const statusType = status?.split('-')[0];

        switch (statusType) {
            // Inspection statuses - Blue variants
            case 'inspection':
                switch (status) {
                    case 'inspection-scheduled':
                    case 'inspection-ongoing':
                        return 'bg-blue-500';  // Active states
                    case 'inspection-completed':
                        return 'bg-blue-600';  // Completed state
                    case 'inspection-cancelled':
                    case 'inspection-no-show':
                    case 'inspection-rescheduled':
                        return 'bg-blue-300';  // Inactive states
                }
                break;

            // KYC statuses - Purple variants
            case 'kyc':
                return status === 'kyc-form-submitted' ? 'bg-purple-600' : 'bg-purple-500';

            // Verification statuses - Green variants
            case 'verification':
                return status === 'verification-completed' ? 'bg-green-600' : 'bg-green-500';

            // Documentation statuses - Orange variants
            case 'document':
                switch (status) {
                    case 'document-completed':
                    case 'document-signed':
                        return 'bg-orange-600';  // Completed states
                    case 'document-rejected':
                    case 'document-cancelled':
                        return 'bg-orange-300';  // Negative states
                    case 'document-pending':
                        return 'bg-orange-400';  // Waiting state
                    default:
                        return 'bg-orange-500';  // Default/ongoing states
                }

            // Discontinued statuses - Red variants
            case 'discontinued':
                return 'bg-red-500';

            // Application statuses - Yellow variants
            case 'application':
                switch (status) {
                    case 'application-approved':
                        return 'bg-yellow-600';
                    case 'application-rejected':
                    case 'application-withdrawn':
                        return 'bg-yellow-300';
                    default:
                        return 'bg-yellow-500';
                }

            // Default fallback
            default:
                return 'bg-gray-500';
        }
    }

    return (
        <div className="verification-layout-apartment-card">
            <span className="verification-layout-apartment-card__img-container">
                {
                    isAvailableForBooking
                        ?
                        <AvailableButton availableAt={props.availableAt} style={{ position: 'absolute', marginTop: '11px', marginRight: '11px' }} />
                        :
                        <UnavailableButton style={{ position: 'absolute', marginTop: '11px', marginRight: '11px' }} />
                }
                <img src={props.img} alt="" />
            </span>
            <div className="verification-layout-apartment-card__details">
                <div className="verification-layout-apartment-card__details__text">
                    <h4>{props.location}</h4>
                    <div className="verification-layout-apartment-card__details__text__rooms">
                        {
                            props.rooms
                                ?
                                props.rooms.map((room, index) => {
                                    return (
                                        <div key={index} className="room">
                                            <h6>{room}</h6>
                                            <img src={DOT} alt="" />
                                        </div>
                                    )
                                })
                                :
                                ''
                        }
                    </div>
                    <div className="verification-layout-apartment-card__details__text__pricing">
                        <h4>{props.pricing}</h4>
                        {/* <button>
                            RENT BREAKDOWN
                            <img src={BLUE_VIEW} alt=""/>
                        </button> */}
                    </div>
                    <div className="verification-layout-apartment-card__details__text__features">
                        {
                            props.additionalFeatures
                                ?
                                props.additionalFeatures.map((feature: any, index) => {
                                    return (
                                        <div style={{ display: 'flex', alignItems: 'center' }} key={index}>
                                            <h5>{feature}</h5>
                                        </div>
                                    )
                                })
                                :
                                ''
                        }
                    </div>
                </div>
                {
                    props.booking_status
                        ?
                        <span className={`
                            inline-flex items-center gap-2 px-4 py-1.5 h-fit rounded-full
                            ${getStatusColor(props.booking_status)}
                            text-white text-sm font-medium
                        `}>
                            <span className="w-2 h-2 rounded-full bg-white opacity-75"></span>
                            {formatBookingStatus(props.booking_status)}
                        </span>
                        :
                        <button className="verification-layout-apartment-card__details__button" onClick={() => router(`/homes/${props.slug}`)} style={{ cursor: 'pointer' }}>
                            VIEW FULL DETAILS
                            <img src={BLUE_ARROW_RIGHT} alt="" />
                        </button>
                }
            </div>
        </div >
    )
}
export default VerificationLayoutApartmentCard;

// const ApartmentFeature = (props: any):JSX.Element => {
//     const feature = props.feature
//     const icon = props.icon
//     return(
//         <div style={{ display: 'flex', alignItems: 'center'}}>
//             {/* <IconPickerItem icon={icon} size={16} color="#616E9E" onClick={()=> {}} /> */}
//             <h5>{feature}</h5>
//         </div>
//     )
// }